import { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'underscore';
import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import AsyncSelector from 'ContentComponents/components/cmv2/components/AsyncSelector';
import { DEFAULT_PAGE_SIZE, ASYNC_SELECTOR_DEBOUNCE } from 'ContentComponents/components/cmv2/constants';
import { getAutomatedEmailOptions, getDefaultAutomatedEmailOptions } from 'ContentData/selectors/emails';
import * as EmailsActions from 'ContentData/actions/Emails';
import { jsx as _jsx } from "react/jsx-runtime";
function mapStateToProps(state, props) {
  const {
    showLegacyEmails
  } = props;
  return {
    defaultOptions: getDefaultAutomatedEmailOptions(state, {
      showLegacyEmails
    }),
    options: getAutomatedEmailOptions(state)
  };
}
const mapDispatchToProps = {
  clearCache: EmailsActions.clearCache,
  fetchAutomatedEmails: EmailsActions.fetchAutomatedEmails,
  saveCache: EmailsActions.saveCache
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.${key}`;
class FollowupEmailSelect extends Component {
  constructor(props) {
    super(props);
    this.loadOptions = this.loadOptions.bind(this);
    this.debouncedLoadOptions = debounce(this.loadOptions, ASYNC_SELECTOR_DEBOUNCE);
    this.state = {
      input: ''
    };
  }
  loadOptions(input, callback, pagination = {
    offset: 0
  }) {
    const {
      clearCache,
      fetchAutomatedEmails
    } = this.props;
    let {
      offset
    } = pagination;
    if (input !== this.state.input) {
      this.setState({
        input
      });
      clearCache();
      offset = 0;
    }
    const query = {
      q: input,
      limit: DEFAULT_PAGE_SIZE,
      offset
    };
    fetchAutomatedEmails(query).then(response => {
      const {
        total
      } = response;
      const {
        options
      } = this.props;
      callback(null, {
        options,
        pagination: {
          hasMore: total > options.length,
          offset: offset + DEFAULT_PAGE_SIZE,
          length: total
        }
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  renderCreateNewEmailLink() {
    const {
      onCreateEmail,
      hasAutomatedEmailEditorAccess,
      hasInlineEmailEditorAccess
    } = this.props;
    if (hasInlineEmailEditorAccess) {
      return /*#__PURE__*/_jsx(Button, {
        onClick: onCreateEmail,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('createNewEmail')
        })
      });
    }
    if (hasAutomatedEmailEditorAccess) {
      return /*#__PURE__*/_jsx(Link, {
        external: true,
        href: Routes.emailContentCreator({
          emailType: 'AUTOMATED'
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('createNewEmail')
        })
      });
    }
    return null;
  }
  render() {
    const {
      clearCache,
      defaultOptions,
      error,
      onChange,
      options,
      placeholder,
      readOnly,
      saveCache,
      value
    } = this.props;
    return /*#__PURE__*/_jsx(AsyncSelector, {
      clearCache: clearCache,
      defaultOptions: defaultOptions,
      dropdownFooter: this.renderCreateNewEmailLink(),
      error: error,
      loadOptions: this.debouncedLoadOptions,
      onChange: e => onChange(e.target.value),
      options: options,
      placeholder: placeholder,
      readOnly: readOnly,
      saveCache: saveCache,
      value: value
    });
  }
}
export default connector(FollowupEmailSelect);